module.exports = __webpack_public_path__ + "img/Wp_2034.3e9908fa.png";